import { appRoutes } from '@clearverify/constants';

import { BreadCrumb } from 'src/types/router';

export const BREADCRUMBS: BreadCrumb[] = [
  { route: appRoutes.inbox.inboxItem, title: 'Home' },
  { route: appRoutes.verifiers.index, title: 'Verifiers' },
  { route: appRoutes.verifiers.detail.index, title: 'Verifier' },
  { route: appRoutes.verifiers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.verifiers.detail.billingSettings, title: 'Billing Settings' },
  { route: appRoutes.verifiers.detail.staff, title: 'Staff' },
  { route: appRoutes.myData.index, title: 'My Data' },
  { route: appRoutes.account.index, title: 'My Account' },
  { route: appRoutes.account.personalInformation, title: 'Personal Information' },
  { route: appRoutes.account.notifications, title: 'Privacy Settings' },
  { route: appRoutes.account.security, title: 'Sign-in & Security' },
  { route: appRoutes.account.setupMfa, title: 'Multi-factor Authentication' },
  { route: appRoutes.account.companyInformation, title: 'Company Information' },
  { route: appRoutes.account.settings, title: 'Settings' },
  { route: appRoutes.account.wallet, title: 'Wallet' },
  { route: appRoutes.account.billing, title: 'Billing' },
  { route: appRoutes.account.billingSettings, title: 'Billing Rules' },
  { route: appRoutes.account.privacySettings, title: 'Privacy Settings' },
  { route: appRoutes.account.generalBillingRules, title: 'General Billing Rules' },
  { route: appRoutes.employees.index, title: 'Employees' },
  { route: appRoutes.myVerify.index, title: 'My Verify' },
  { route: appRoutes.employers.index, title: 'Employers' },
  { route: appRoutes.employers.detail.index, title: 'Employer' },
  { route: appRoutes.employers.detail.wallet, title: 'Billing' },
  { route: appRoutes.employers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.employers.detail.staff, title: 'Staff' },
  { route: appRoutes.employers.detail.employees, title: 'Employees' },
  { route: appRoutes.employers.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.index, title: 'PEOs' },
  { route: appRoutes.peos.detail.index, title: 'Peo' },
  { route: appRoutes.peos.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.peos.detail.staff, title: 'Staff' },
  { route: appRoutes.peos.detail.employees, title: 'Employees' },
  { route: appRoutes.peos.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.detail.employers, title: 'Employers' },
  { route: appRoutes.peos.detail.billing, title: 'Billing' },
  { route: appRoutes.clearVerifyStaff.index, title: 'Staff' },
  { route: appRoutes.employerStaff.index, title: 'Staff' },
  { route: appRoutes.verifierStaff.index, title: 'Staff' },
  { route: appRoutes.peoStaff.index, title: 'Staff' },
  { route: appRoutes.reports.index, title: 'Reports' },
  { route: appRoutes.reports.dataDisputes, title: 'Data Disputes' },
  { route: appRoutes.reports.dashboard, title: 'Dashboard' },
  { route: appRoutes.reports.verificationRequests, title: 'Verification Requests' },
  { route: appRoutes.reports.requests, title: 'Requests' },
  { route: appRoutes.resources.index, title: 'Resources' },
  { route: appRoutes.emailTracker.index, title: 'Email Tracker' },
  { route: appRoutes.apiIntegrations.index, title: 'API & Integrations' },
  { route: appRoutes.apiIntegrations.usageLogs, title: 'Usage Logs' },
  { route: appRoutes.dashboard.index, title: 'Dashboard' },
];

export const BREADCRUMBS_CLEAR_VERIFY_ADMIN: BreadCrumb[] = [
  { route: appRoutes.inbox.index, title: 'Inbox' },
  { route: appRoutes.verifiers.index, title: 'Verifiers' },
  { route: appRoutes.verifiers.detail.index, title: 'Verifier' },
  { route: appRoutes.verifiers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.verifiers.detail.billingSettings, title: 'Billing Settings' },
  { route: appRoutes.verifiers.detail.staff, title: 'Staff' },
  { route: appRoutes.myData.index, title: 'My Data' },
  { route: appRoutes.account.index, title: 'My Account' },
  { route: appRoutes.account.personalInformation, title: 'Personal Information' },
  { route: appRoutes.account.notifications, title: 'Privacy Settings' },
  { route: appRoutes.account.security, title: 'Sign-in & Security' },
  { route: appRoutes.account.setupMfa, title: 'Multi-factor Authentication' },
  { route: appRoutes.account.companyInformation, title: 'Company Information' },
  { route: appRoutes.account.settings, title: 'Settings' },
  { route: appRoutes.account.wallet, title: 'Wallet' },
  { route: appRoutes.account.billing, title: 'Billing' },
  { route: appRoutes.account.billingSettings, title: 'Billing Rules' },
  { route: appRoutes.account.privacySettings, title: 'Privacy Settings' },
  { route: appRoutes.account.generalBillingRules, title: 'General Billing Rules' },
  { route: appRoutes.employees.index, title: 'Employees' },
  { route: appRoutes.myVerify.index, title: 'My Verify' },
  { route: appRoutes.employers.index, title: 'Employers' },
  { route: appRoutes.employers.detail.index, title: 'Employer' },
  { route: appRoutes.employers.detail.wallet, title: 'Billing' },
  { route: appRoutes.employers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.employers.detail.staff, title: 'Staff' },
  { route: appRoutes.employers.detail.employees, title: 'Employees' },
  { route: appRoutes.employers.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.index, title: 'PEOs' },
  { route: appRoutes.peos.detail.index, title: 'Peo' },
  { route: appRoutes.peos.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.peos.detail.staff, title: 'Staff' },
  { route: appRoutes.peos.detail.employees, title: 'Employees' },
  { route: appRoutes.peos.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.detail.employers, title: 'Employers' },
  { route: appRoutes.peos.detail.billing, title: 'Billing' },
  { route: appRoutes.clearVerifyStaff.index, title: 'Staff' },
  { route: appRoutes.employerStaff.index, title: 'Staff' },
  { route: appRoutes.verifierStaff.index, title: 'Staff' },
  { route: appRoutes.peoStaff.index, title: 'Staff' },
  { route: appRoutes.reports.index, title: 'Reports' },
  { route: appRoutes.reports.dataDisputes, title: 'Data Disputes' },
  { route: appRoutes.reports.dashboard, title: 'Dashboard' },
  { route: appRoutes.reports.verificationRequests, title: 'Verification Requests' },
  { route: appRoutes.reports.requests, title: 'Requests' },
  { route: appRoutes.resources.index, title: 'Resources' },
  { route: appRoutes.emailTracker.index, title: 'Email Tracker' },
  { route: appRoutes.apiIntegrations.index, title: 'API & Integrations' },
  { route: appRoutes.apiIntegrations.usageLogs, title: 'Usage Logs' },
  { route: appRoutes.dashboard.index, title: 'Dashboard' },
];

export const BREADCRUMBS_EMPLOYER_ADMIN: BreadCrumb[] = [
  { route: appRoutes.inbox.inboxItem, title: 'Home' },
  { route: appRoutes.verifiers.index, title: 'Verifiers' },
  { route: appRoutes.verifiers.detail.index, title: 'Verifier' },
  { route: appRoutes.verifiers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.verifiers.detail.billingSettings, title: 'Billing Settings' },
  { route: appRoutes.verifiers.detail.staff, title: 'Staff' },
  { route: appRoutes.myData.index, title: 'My Data' },
  { route: appRoutes.account.index, title: 'My Account' },
  { route: appRoutes.account.personalInformation, title: 'Personal Information' },
  { route: appRoutes.account.notifications, title: 'Privacy Settings' },
  { route: appRoutes.account.security, title: 'Sign-in & Security' },
  { route: appRoutes.account.setupMfa, title: 'Multi-factor Authentication' },
  { route: appRoutes.account.companyInformation, title: 'Company Information' },
  { route: appRoutes.account.settings, title: 'Settings' },
  { route: appRoutes.account.wallet, title: 'Wallet' },
  { route: appRoutes.account.billing, title: 'Billing' },
  { route: appRoutes.account.billingSettings, title: 'Billing Rules' },
  { route: appRoutes.account.privacySettings, title: 'Privacy Settings' },
  { route: appRoutes.account.generalBillingRules, title: 'General Billing Rules' },
  { route: appRoutes.employees.index, title: 'Employees' },
  { route: appRoutes.myVerify.index, title: 'My Verify' },
  { route: appRoutes.employers.index, title: 'Employers' },
  { route: appRoutes.employers.detail.index, title: 'Employer' },
  { route: appRoutes.employers.detail.wallet, title: 'Billing' },
  { route: appRoutes.employers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.employers.detail.staff, title: 'Staff' },
  { route: appRoutes.employers.detail.employees, title: 'Employees' },
  { route: appRoutes.employers.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.index, title: 'PEOs' },
  { route: appRoutes.peos.detail.index, title: 'Peo' },
  { route: appRoutes.peos.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.peos.detail.staff, title: 'Staff' },
  { route: appRoutes.peos.detail.employees, title: 'Employees' },
  { route: appRoutes.peos.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.detail.employers, title: 'Employers' },
  { route: appRoutes.peos.detail.billing, title: 'Billing' },
  { route: appRoutes.clearVerifyStaff.index, title: 'Staff' },
  { route: appRoutes.employerStaff.index, title: 'Staff' },
  { route: appRoutes.verifierStaff.index, title: 'Staff' },
  { route: appRoutes.peoStaff.index, title: 'Staff' },
  { route: appRoutes.reports.index, title: 'Dashboard & Reports' },
  { route: appRoutes.reports.dataDisputes, title: 'Data Disputes' },
  { route: appRoutes.reports.dashboard, title: 'Dashboard' },
  { route: appRoutes.reports.verificationRequests, title: 'Verification Requests' },
  { route: appRoutes.reports.requests, title: 'Requests' },
  { route: appRoutes.resources.index, title: 'Resources' },
  { route: appRoutes.emailTracker.index, title: 'Email Tracker' },
  { route: appRoutes.dashboard.index, title: 'Dashboard' },
];

export const BREADCRUMBS_PEO_ADMIN: BreadCrumb[] = [
  { route: appRoutes.inbox.inboxItem, title: 'Home' },
  { route: appRoutes.verifiers.index, title: 'Verifiers' },
  { route: appRoutes.verifiers.detail.index, title: 'Verifier' },
  { route: appRoutes.verifiers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.verifiers.detail.billingSettings, title: 'Billing Settings' },
  { route: appRoutes.verifiers.detail.staff, title: 'Staff' },
  { route: appRoutes.myData.index, title: 'My Data' },
  { route: appRoutes.account.index, title: 'My Account' },
  { route: appRoutes.account.personalInformation, title: 'Personal Information' },
  { route: appRoutes.account.notifications, title: 'Privacy Settings' },
  { route: appRoutes.account.security, title: 'Sign-in & Security' },
  { route: appRoutes.account.setupMfa, title: 'Multi-factor Authentication' },
  { route: appRoutes.account.companyInformation, title: 'Company Information' },
  { route: appRoutes.account.settings, title: 'Settings' },
  { route: appRoutes.account.wallet, title: 'Wallet' },
  { route: appRoutes.account.billing, title: 'Billing' },
  { route: appRoutes.account.billingSettings, title: 'Billing Rules' },
  { route: appRoutes.account.privacySettings, title: 'Privacy Settings' },
  { route: appRoutes.account.generalBillingRules, title: 'General Billing Rules' },
  { route: appRoutes.employees.index, title: 'Employees' },
  { route: appRoutes.myVerify.index, title: 'My Verify' },
  { route: appRoutes.employers.index, title: 'Employers' },
  { route: appRoutes.employers.detail.index, title: 'Employer' },
  { route: appRoutes.employers.detail.wallet, title: 'Billing' },
  { route: appRoutes.employers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.employers.detail.staff, title: 'Staff' },
  { route: appRoutes.employers.detail.employees, title: 'Employees' },
  { route: appRoutes.employers.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.index, title: 'PEOs' },
  { route: appRoutes.peos.detail.index, title: 'Peo' },
  { route: appRoutes.peos.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.peos.detail.staff, title: 'Staff' },
  { route: appRoutes.peos.detail.employees, title: 'Employees' },
  { route: appRoutes.peos.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.detail.employers, title: 'Employers' },
  { route: appRoutes.peos.detail.billing, title: 'Billing' },
  { route: appRoutes.clearVerifyStaff.index, title: 'Staff' },
  { route: appRoutes.employerStaff.index, title: 'Staff' },
  { route: appRoutes.verifierStaff.index, title: 'Staff' },
  { route: appRoutes.peoStaff.index, title: 'Staff' },
  { route: appRoutes.reports.index, title: 'Dashboard & Reports' },
  { route: appRoutes.reports.dataDisputes, title: 'Data Disputes' },
  { route: appRoutes.reports.dashboard, title: 'Dashboard' },
  { route: appRoutes.reports.verificationRequests, title: 'Verification Requests' },
  { route: appRoutes.reports.requests, title: 'Requests' },
  { route: appRoutes.resources.index, title: 'Resources' },
  { route: appRoutes.emailTracker.index, title: 'Email Tracker' },
  { route: appRoutes.dashboard.index, title: 'Dashboard' },
];

export const BREADCRUMBS_PEO_PAYROLL_PROVIDER: BreadCrumb[] = [
  { route: appRoutes.inbox.inboxItem, title: 'Home' },
  { route: appRoutes.verifiers.index, title: 'Verifiers' },
  { route: appRoutes.verifiers.detail.index, title: 'Verifier' },
  { route: appRoutes.verifiers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.verifiers.detail.billingSettings, title: 'Billing Settings' },
  { route: appRoutes.verifiers.detail.staff, title: 'Staff' },
  { route: appRoutes.myData.index, title: 'My Data' },
  { route: appRoutes.account.index, title: 'My Account' },
  { route: appRoutes.account.personalInformation, title: 'Personal Information' },
  { route: appRoutes.account.notifications, title: 'Privacy Settings' },
  { route: appRoutes.account.security, title: 'Sign-in & Security' },
  { route: appRoutes.account.setupMfa, title: 'Multi-factor Authentication' },
  { route: appRoutes.account.companyInformation, title: 'Company Information' },
  { route: appRoutes.account.settings, title: 'Settings' },
  { route: appRoutes.account.wallet, title: 'Wallet' },
  { route: appRoutes.account.billing, title: 'Billing' },
  { route: appRoutes.account.billingSettings, title: 'Billing Rules' },
  { route: appRoutes.account.privacySettings, title: 'Privacy Settings' },
  { route: appRoutes.account.generalBillingRules, title: 'General Billing Rules' },
  { route: appRoutes.employees.index, title: 'Employees' },
  { route: appRoutes.myVerify.index, title: 'My Verify' },
  { route: appRoutes.employers.index, title: 'Employers' },
  { route: appRoutes.employers.detail.index, title: 'Employer' },
  { route: appRoutes.employers.detail.wallet, title: 'Billing' },
  { route: appRoutes.employers.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.employers.detail.staff, title: 'Staff' },
  { route: appRoutes.employers.detail.employees, title: 'Employees' },
  { route: appRoutes.employers.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.index, title: 'PEOs' },
  { route: appRoutes.peos.detail.index, title: 'Peo' },
  { route: appRoutes.peos.detail.companyInformation, title: 'Company Information' },
  { route: appRoutes.peos.detail.staff, title: 'Staff' },
  { route: appRoutes.peos.detail.employees, title: 'Employees' },
  { route: appRoutes.peos.detail.settings, title: 'Settings' },
  { route: appRoutes.peos.detail.employers, title: 'Employers' },
  { route: appRoutes.peos.detail.billing, title: 'Billing' },
  { route: appRoutes.clearVerifyStaff.index, title: 'Staff' },
  { route: appRoutes.employerStaff.index, title: 'Staff' },
  { route: appRoutes.verifierStaff.index, title: 'Staff' },
  { route: appRoutes.peoStaff.index, title: 'Staff' },
  { route: appRoutes.reports.index, title: 'Dashboard & Reports' },
  { route: appRoutes.reports.dataDisputes, title: 'Data Disputes' },
  { route: appRoutes.reports.dashboard, title: 'Dashboard' },
  { route: appRoutes.reports.verificationRequests, title: 'Verification Requests' },
  { route: appRoutes.reports.requests, title: 'Requests' },
  { route: appRoutes.resources.index, title: 'Resources' },
  { route: appRoutes.emailTracker.index, title: 'Email Tracker' },
  { route: appRoutes.dashboard.index, title: 'Dashboard' },
];
